<script lang="ts" setup>
import { useArticleFont } from "@/common/composables/use-article-font.composable";

const { articleFontClass } = useArticleFont();
</script>

<template>
  <!-- Used by element-registry.ts to find the first article -->
  <article class="article-content" :class="articleFontClass">
    <slot />
  </article>
</template>
